export enum WhatsAppMessageType {
  Incoming = 'incoming',
  Outgoing = 'outgoing',
}
